import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { computed, ref } from "vue";

import UserManagementDialog from "@/components/UserManagementDialog.vue";
import type { ClusterRole } from "@/stores/user-store";
import type { OrganizationUser } from "@/stores/users-store";

type DialogMode = "add" | "edit";

export interface UserFormData {
    email: string;
    name?: string;
    roles: ClusterRole[];
    userId: string;
}

export interface UserDialogData {
    mode: DialogMode;
    userData?: OrganizationUser;
}

export const useUserManagementDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const openAddUser = () => {
        dialogRef.value = dialog.open(UserManagementDialog, {
            props: {
                header: "Add User",
                style: {
                    width: "450px",
                },
                modal: true,
                closable: true,
                draggable: false,
            },
            data: {
                mode: "add",
            } as UserDialogData,
        });

        return dialogRef.value;
    };

    const openEditUser = (user: OrganizationUser) => {
        dialogRef.value = dialog.open(UserManagementDialog, {
            props: {
                header: "Update User Role",
                style: {
                    width: "450px",
                },
                modal: true,
                closable: true,
                draggable: false,
            },
            data: {
                mode: "edit",
                userData: user,
            } as UserDialogData,
        });

        return dialogRef.value;
    };

    return {
        openAddUser,
        openEditUser,
        isVisible,
    };
};
